module.exports = __webpack_public_path__ + "static/media/gray-check.085d5832.svg";